// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-styles--header--Gpvu0 {
  display: block;
}

.src-containers-Profile-styles--content--X0Ozt {
  padding: 0;
  background-color: transparent;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-styles--content--X0Ozt {
    background-color: #fff;
    background-color: var(--mainBackground);
}
  }

.src-containers-Profile-styles--footer--rHcE8 {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #fff;
  background-color: var(--mainBackground);
  font-size: 15px;
  line-height: 1;
  text-align: center;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-styles--footer--rHcE8 {
    padding-top: 50px;
    padding-bottom: 50px;
    font-size: 14px;
    line-height: 1.07;
}
  }

.src-containers-Profile-styles--footer--rHcE8 p {
  margin-top: 0;
  margin-bottom: 0;
}

.src-containers-Profile-styles--footer--rHcE8 p + p {
    margin-top: 25px;
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,6BAA6B;AAK/B;;AAHE;;AAJF;IAKI,sBAAuC;IAAvC,uCAAuC;AAE3C;EADE;;AAGF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAuC;EAAvC,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,kBAAkB;AAQpB;;AANE;;AARF;IASI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AAErB;EADE;;AAGF;EACE,aAAa;EACb,gBAAgB;AAKlB;;AAHE;IACE,gBAAgB;EAClB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.header {\n  display: block;\n}\n\n.content {\n  padding: 0;\n  background-color: transparent;\n\n  @media (--desktop) {\n    background-color: var(--mainBackground);\n  }\n}\n\n.footer {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  background-color: var(--mainBackground);\n  font-size: 15px;\n  line-height: 1;\n  text-align: center;\n\n  @media (--desktop) {\n    padding-top: 50px;\n    padding-bottom: 50px;\n    font-size: 14px;\n    line-height: 1.07;\n  }\n}\n\n.footer p {\n  margin-top: 0;\n  margin-bottom: 0;\n\n  & + p {\n    margin-top: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `src-containers-Profile-styles--header--Gpvu0`,
	"content": `src-containers-Profile-styles--content--X0Ozt`,
	"footer": `src-containers-Profile-styles--footer--rHcE8`
};
module.exports = ___CSS_LOADER_EXPORT___;
